// Logo resmi platform partner (aset Figma). Logo dari CMS (`logoUrl`) tetap diutamakan.
const PLATFORM_LOGO: Record<string, string> = {
  TIKTOK: '/assets/home/platform-tiktok.png',
  SHOPEE: '/assets/home/platform-shopee.png',
  TOKOPEDIA: '/assets/home/platform-tokopedia.png',
  BLIBLI: '/assets/home/platform-blibli.png',
  LAZADA: '/assets/home/platform-lazada.png',
};

export function platformLogo(platform: { code: string; logoUrl: string | null }): string | null {
  return platform.logoUrl ?? PLATFORM_LOGO[platform.code.toUpperCase()] ?? null;
}
